import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../../../../app/store";
import CompanyNamePICModel from "../../../../CompanyNamePIC/models/CompanyNamePICModel";

interface SupportSheetPrincileState {
    selectedItem: CompanyNamePICModel | null,
    selectedId: string,
    companyName: string,
    showInput: boolean,
    triggerPrincipleChange: number,
}

const initialState: SupportSheetPrincileState = {
    selectedItem: null,
    selectedId: "",
    companyName: "",
    showInput: false,
    triggerPrincipleChange: 0,
}

export const SupportSheetPrincipleSlice = createSlice({
    name: "SupportSheetPrinciple",
    initialState,
    reducers: {
        setSelectedItem: (state, action: PayloadAction<CompanyNamePICModel | null>) => {
            state.selectedItem = action.payload;
        },
        setSelectedId: (state, action: PayloadAction<string>) => {
            state.selectedId = action.payload;
        },
        setCompanyName: (state, action: PayloadAction<string>) => {
            state.companyName = action.payload;
        },
        setShowPrincipleInput: (state, action: PayloadAction<boolean>) => {
            state.showInput = action.payload;
        },
        setTriggerPrincipleChange: (state, action: PayloadAction<number>) => {
            state.triggerPrincipleChange = action.payload;
        },
    }
});

export const SupportSheetPrincipleSelector = createSelector(
    (state: RootState) => state.principle,
    (data) => data
);

export const {
    setSelectedItem,
    setSelectedId,
    setCompanyName,
    setShowPrincipleInput,
    setTriggerPrincipleChange,
} = SupportSheetPrincipleSlice.actions;

export default SupportSheetPrincipleSlice.reducer;